module.exports = __webpack_public_path__ + "static/media/Dysmate-A_compressed.6cf09ebf.pdf";